export const BUTTON_BORDER_SIZE = "2px";
